var _style, _g, _g2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElvin(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 900 1000",
    style: {
      enableBackground: "new 0 0 900 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#231F20;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1000.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M918,9923c-136-299-218-649-218-930c0-270,75-695,206-1177c30-109,53-201,50-203c-8-9-131,55-230,121 c-55,36-101,65-102,63c-1-1-8-58-15-127c-31-323,20-676,142-981c48-122,162-350,217-434c129-199,317-355,599-496l133-66l-43-12 c-57-17-158-73-228-126c-154-119-303-337-374-546l-24-70l44-47c141-150,703-939,780-1095c25-53,35-130,21-175c-6-17-15-22-45-22 c-99,0-251-129-320-271c-58-122-74-217-69-403c4-119,10-166,28-221c85-266,292-487,627-669l76-41l37-105c134-382,329-703,561-925 c101-96,318-260,529-400C3938,142,4472-43,4896,9c364,46,819,243,1294,560c214,143,431,310,533,410c221,215,416,534,542,887 l47,131l72,39c231,125,444,311,539,471c93,155,136,339,123,518c-16,208-68,337-181,451c-88,89-158,127-226,122c-44-3-49-1-49,18 c0,70,128,282,613,1018l191,288l-12,47c-18,69-102,233-176,344c-131,196-228,297-393,409c-74,49-266,148-290,148 c-25,0-22,20,11,77c50,83,113,247,146,376c143,570-29,1111-493,1553c-320,304-736,549-1325,778c-274,106-444,179-682,291 c-410,193-946,495-1307,736l-103,69v-80c0-212,39-495,88-640c34-99,92-242,128-311c20-41,22-49,8-49c-66,0-738,165-1018,250 c-698,212-1292,527-1992,1057l-31,23L918,9923z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M289.7,576.9c55.1,7.1,77.4,13.3,124.3,34.6c24.6,11.2,40.9,15.5,58,15.5c17.9,0,33.2-4.1,59.7-16 c42.6-19.2,60.5-24.6,104.3-31.4c44.9-7,82-7.4,103.5-1.1c9.4,2.7,13,8.9,14.3,24.2c2.3,27-7,99-14.7,114.2 c-5.6,10.8-45.5,33.5-78.4,44.5c-25.8,8.7-47.3,12.6-72.9,13.3c-22,0.7-28.2-0.4-41.6-6.9c-10.9-5.3-20.3-14.2-33.2-31.2 c-17.7-23.4-28.8-32.1-41.2-32c-11.9,0.1-22.7,8.6-39.8,31.3c-11.5,15.3-14.9,19.1-22,24.6C396.4,771,383.4,775,363.3,775 c-47.1,0-100.9-16.6-140.7-43.2C206.1,720.6,204,717.6,200,699c-4.1-18.9-10-69.6-10-85.7c0-17.3,3.2-28.4,9.1-32.1 c4-2.4,12.7-4.8,22.5-6.1C232.9,573.5,271.4,574.5,289.7,576.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElvin);
export default __webpack_public_path__ + "static/media/elvin.d870501f7e7f5a2c4fff6e115be5f1f3.svg";
export { ForwardRef as ReactComponent };